<template>
  <div>
  
    <CCard style="margin-top: 20px">
        <CCol xs="12" lg="12" style="margin-top: 20px">
        
            <CTabs variant="pills">
              <CTab title="Prediction Table" active>
                <hr>
                <Predictiontable></Predictiontable>
              </CTab>
              <CTab title="Prediction Answer">
                <hr>
              <Predictionanswer></Predictionanswer>
              </CTab> 
  
            </CTabs>
        
      </CCol>
    
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import Predictionanswer from "./predictionanswer.vue"
import Predictiontable from "./predictiontable.vue"
export default {
  components: {
    Predictionanswer,
    Predictiontable
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
   
     
    };
  },
  watch: {
   
  },
  methods: {
    
    // sendmsg(){}
  },
  created() {

  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>